module.exports = __webpack_public_path__ + "img/full2-min.30c40e34.png";